export default __webpack_public_path__ + "static/media/thankyoukeyvis_voucher100_tab.9da378af.png";